import React, { useMemo } from "react";
import { FieldControl } from "spark-core-dx/components";
import { SystemTypes } from "spark-core-dx/services";
import { useVisualFormContext } from "../../../contexts/VisualFormContext";
import {
  buildVisualExecutionModeOptions,
  isForcedVisualExecutionMode,
  normalizeVisualExecutionMode,
} from "../../../visualExecutionModes";

export const ExecutionMode = () => {
  const { visualObject, setVisualExecutionMode } = useVisualFormContext();
  const modelKind = Number(visualObject?.ModelKind ?? 0);
  const supportsRealTime = !!visualObject?.DefaultQueryState?.SupportsRealTime;
  const options = useMemo(
    () => buildVisualExecutionModeOptions(modelKind, supportsRealTime),
    [modelKind, supportsRealTime]
  );
  const selectedValue = normalizeVisualExecutionMode(modelKind, visualObject?.ExecutionMode, supportsRealTime);
  const isForced = isForcedVisualExecutionMode(modelKind);

  return (
    <FieldControl
      fieldMetadata={{
        FieldType: SystemTypes.UIFieldType.SelectList,
        FieldName: "ExecutionMode",
        DisplayName: "Execution Mode",
        Description: isForced
          ? "This visual is locked to a required execution mode."
          : !supportsRealTime
            ? "RealTime is hidden because optional grouping is enabled for this visual."
            : "Choose how this visual executes. Server uses the current dashboard mode: design mode runs against the linked workspace runtime, and view mode runs against the published workspace artifact.",
        IsRequired: true,
        DataJson: options,
      }}
      groupId={"visual"}
      value={selectedValue}
      disabled={!modelKind || isForced}
      onChange={(value) => {
        setVisualExecutionMode(value);
      }}
    />
  );
};
